export default class TextAnim
{

    static nodes = {
        animItems: document.querySelectorAll('.information__text, .info__text, .points__value, .points__text, .past__text'),
    }

    constructor() {
        if (TextAnim.nodes.animItems.length > 0) { // анимация появления текста
            window.addEventListener('scroll', animOnScroll);

            function animOnScroll() {
                for (let index = 0; index < TextAnim.nodes.animItems.length; index++) {
                    const animItem = TextAnim.nodes.animItems[index];
                    const animItemHeight = animItem.offsetHeight;
                    const animItemOffset = offset(animItem).top;
                    const animStart = 4;

                    let animItemPoint = window.innerHeight - animItemHeight / animStart;
                    if (animItemHeight > window.innerHeight) {
                        animItemPoint = window.innerHeight - window.innerHeight / animStart;
                    }

                    if ((pageYOffset > animItemOffset - animItemPoint) && pageYOffset < (animItemOffset + animItemHeight)) {
                        animItem.classList.add('_animate');
                    } else {
                        if (!animItem.classList.contains('random')) {
                            // animItem.classList.remove('_animate');
                        }
                    }
                }
            }

            function offset(el) {
                const rect = el.getBoundingClientRect(),
                    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                return { top: rect.top + scrollTop, left: rect.left + scrollLeft }

            }
            setTimeout(() => {
                animOnScroll();
            }, 100);
        }
    }
}